// Local translations for the public auth views (login, admin login, password
// recovery, password assign). These pages must NOT load the Google Translate
// widget: its DOM rewriting breaks the invisible Google Sign-In iframe overlay
// and the button becomes unclickable. The in-app translator (GoogleTranslate.js
// in AppHeader) still runs after login; setLoginLang keeps its googtrans cookie
// in sync so the chosen language carries over into the app.

const STORAGE_KEY = 'vacway_login_lang'

export const LANGS = [
  { code: 'es', flag: 'es',  label: 'Español' },
  { code: 'en', flag: 'en',  label: 'English' },
  { code: 'fr', flag: 'fr',  label: 'Français' },
  { code: 'de', flag: 'gr',  label: 'Deutsch' },
  { code: 'it', flag: 'it',  label: 'Italiano' },
  { code: 'pt', flag: 'pt',  label: 'Português' },
  { code: 'pl', flag: 'pl',  label: 'Polski' },
  { code: 'tr', flag: 'tr',  label: 'Türkçe' },
  { code: 'cs', flag: 'cz',  label: 'Čeština' },
  { code: 'sk', flag: 'sk',  label: 'Slovenčina' },
  { code: 'ca', flag: 'cat', label: 'Català' },
  { code: 'nl', flag: 'nl',  label: 'Nederlands' },
  { code: 'no', flag: 'nw',  label: 'Norsk' },
]

const STRINGS = {
  es: {
    noAccessProduct: 'Tu cuenta VACWAY aún no tiene acceso a {product}.',
    requestInfo: 'Solicitar información',
    requestInfoSent: '¡Solicitud enviada! Te contactaremos muy pronto.',
    email: 'Email',
    password: 'Contraseña',
    emailPlaceholder: 'tu@email.com',
    securityCheck: 'Verificación de seguridad',
    newQuestion: 'Nueva pregunta',
    forgotPassword: '¿Has olvidado tu contraseña?',
    signIn: 'Entrar',
    signingIn: 'Entrando...',
    emailPasswordRequired: 'Email y contraseña son obligatorios.',
    captchaRequired: 'Debes responder la verificación de seguridad.',
    captchaWrong: 'Respuesta de verificación incorrecta.',
    tooManyAttempts: 'Demasiados intentos fallidos. Espera {time}.',
    blocked: 'Acceso temporalmente bloqueado.',
    loginError: 'Error al iniciar sesión.',
    or: 'o',
    googleSignIn: 'Iniciar sesión con Google',
    microsoftSignIn: 'Iniciar sesión con Microsoft',
    googleError: 'Error al iniciar sesión con Google.',
    microsoftError: 'No se pudo iniciar sesión con Microsoft.',
    adminMode: 'MODO ADMINISTRADOR',
    promoterMode: 'MODO PROMOTOR',
    mfaSent: 'Hemos enviado un código de verificación a tu correo electrónico. Introdúcelo para continuar.',
    mfaCodeLabel: 'Código de verificación',
    verify: 'Verificar',
    verifying: 'Verificando...',
    resendCode: 'Reenviar código',
    back: 'Volver',
    mfaCodeRequired: 'Introduce el código de verificación.',
    mfaNewCodeSent: 'Te hemos enviado un nuevo código.',
    mfaResendError: 'No se pudo reenviar el código.',
    waitSeconds: 'Espera {s}s.',
    codeWrong: 'Código incorrecto.',
    attemptsRemaining: '{n} intentos restantes',
    mfaLinkIntro: 'Has abierto el enlace de verificación. Confirma para iniciar sesión',
    mfaLinkDevice: 'en este dispositivo',
    mfaLinkButton: 'Entrar en este dispositivo',
    backToLogin: 'Volver al inicio de sesión',
    linkInvalid: 'El enlace no es válido o ha caducado.',
    recoveryIntro: 'Introduce tu email y te enviaremos instrucciones para restablecer tu contraseña.',
    emailRequired: 'El email es obligatorio.',
    requestError: 'Error al procesar la solicitud.',
    sending: 'Enviando...',
    sendInstructions: 'Enviar instrucciones',
    recoverySent1: 'Hemos enviado un correo al email facilitado.',
    recoverySent2: 'Sigue los pasos para recuperar la contraseña.',
    backToHome: 'Volver al inicio',
    assignIntro: 'Elige una nueva contraseña segura para tu cuenta.',
    newPassword: 'Nueva contraseña',
    confirmPasswordLabel: 'Confirmar contraseña',
    passwordHint: 'Mín. 8 caracteres, una mayúscula, un número y un símbolo.',
    pwMin: 'Mínimo 8 caracteres.',
    pwUpper: 'Debe incluir al menos una mayúscula.',
    pwNumber: 'Debe incluir al menos un número.',
    pwSymbol: 'Debe incluir al menos un símbolo.',
    pwMismatch: 'Las contraseñas no coinciden.',
    assignLinkInvalid: 'Enlace de cambio de contraseña inválido.',
    saveError: 'Error al guardar la contraseña.',
    saving: 'Guardando...',
    savePassword: 'Guardar contraseña',
    assignSuccess1: 'Tu contraseña se ha cambiado correctamente.',
    assignSuccess2: 'Ya puedes iniciar sesión.',
  },
  en: {
    noAccessProduct: 'Your VACWAY account does not have access to {product} yet.',
    requestInfo: 'Request information',
    requestInfoSent: 'Request sent! We will contact you very soon.',
    email: 'Email',
    password: 'Password',
    emailPlaceholder: 'you@email.com',
    securityCheck: 'Security check',
    newQuestion: 'New question',
    forgotPassword: 'Forgot your password?',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    emailPasswordRequired: 'Email and password are required.',
    captchaRequired: 'Please answer the security check.',
    captchaWrong: 'Incorrect security check answer.',
    tooManyAttempts: 'Too many failed attempts. Wait {time}.',
    blocked: 'Access temporarily blocked.',
    loginError: 'Sign-in failed.',
    or: 'or',
    googleSignIn: 'Sign in with Google',
    microsoftSignIn: 'Sign in with Microsoft',
    googleError: 'Could not sign in with Google.',
    microsoftError: 'Could not sign in with Microsoft.',
    adminMode: 'ADMINISTRATOR MODE',
    promoterMode: 'PROMOTER MODE',
    mfaSent: 'We have sent a verification code to your email. Enter it to continue.',
    mfaCodeLabel: 'Verification code',
    verify: 'Verify',
    verifying: 'Verifying...',
    resendCode: 'Resend code',
    back: 'Back',
    mfaCodeRequired: 'Enter the verification code.',
    mfaNewCodeSent: 'We have sent you a new code.',
    mfaResendError: 'Could not resend the code.',
    waitSeconds: 'Wait {s}s.',
    codeWrong: 'Incorrect code.',
    attemptsRemaining: '{n} attempts remaining',
    mfaLinkIntro: 'You have opened the verification link. Confirm to sign in',
    mfaLinkDevice: 'on this device',
    mfaLinkButton: 'Sign in on this device',
    backToLogin: 'Back to sign in',
    linkInvalid: 'The link is invalid or has expired.',
    recoveryIntro: 'Enter your email and we will send you instructions to reset your password.',
    emailRequired: 'Email is required.',
    requestError: 'Could not process the request.',
    sending: 'Sending...',
    sendInstructions: 'Send instructions',
    recoverySent1: 'We have sent an email to the address provided.',
    recoverySent2: 'Follow the steps to recover your password.',
    backToHome: 'Back to home',
    assignIntro: 'Choose a new secure password for your account.',
    newPassword: 'New password',
    confirmPasswordLabel: 'Confirm password',
    passwordHint: 'Min. 8 characters, one uppercase letter, one number and one symbol.',
    pwMin: 'Minimum 8 characters.',
    pwUpper: 'Must include at least one uppercase letter.',
    pwNumber: 'Must include at least one number.',
    pwSymbol: 'Must include at least one symbol.',
    pwMismatch: 'Passwords do not match.',
    assignLinkInvalid: 'Invalid password reset link.',
    saveError: 'Could not save the password.',
    saving: 'Saving...',
    savePassword: 'Save password',
    assignSuccess1: 'Your password has been changed successfully.',
    assignSuccess2: 'You can now sign in.',
  },
  fr: {
    noAccessProduct: 'Votre compte VACWAY n\'a pas encore accès à {product}.',
    requestInfo: 'Demander des informations',
    requestInfoSent: 'Demande envoyée ! Nous vous contacterons très bientôt.',
    email: 'Email',
    password: 'Mot de passe',
    emailPlaceholder: 'vous@email.com',
    securityCheck: 'Vérification de sécurité',
    newQuestion: 'Nouvelle question',
    forgotPassword: 'Mot de passe oublié ?',
    signIn: 'Se connecter',
    signingIn: 'Connexion...',
    emailPasswordRequired: "L'email et le mot de passe sont obligatoires.",
    captchaRequired: 'Veuillez répondre à la vérification de sécurité.',
    captchaWrong: 'Réponse de vérification incorrecte.',
    tooManyAttempts: 'Trop de tentatives échouées. Attendez {time}.',
    blocked: 'Accès temporairement bloqué.',
    loginError: 'Erreur de connexion.',
    or: 'ou',
    googleSignIn: 'Se connecter avec Google',
    microsoftSignIn: 'Se connecter avec Microsoft',
    googleError: 'Impossible de se connecter avec Google.',
    microsoftError: 'Impossible de se connecter avec Microsoft.',
    adminMode: 'MODE ADMINISTRATEUR',
    promoterMode: 'MODE PROMOTEUR',
    mfaSent: 'Nous avons envoyé un code de vérification à votre adresse email. Saisissez-le pour continuer.',
    mfaCodeLabel: 'Code de vérification',
    verify: 'Vérifier',
    verifying: 'Vérification...',
    resendCode: 'Renvoyer le code',
    back: 'Retour',
    mfaCodeRequired: 'Saisissez le code de vérification.',
    mfaNewCodeSent: 'Nous vous avons envoyé un nouveau code.',
    mfaResendError: 'Impossible de renvoyer le code.',
    waitSeconds: 'Attendez {s}s.',
    codeWrong: 'Code incorrect.',
    attemptsRemaining: '{n} tentatives restantes',
    mfaLinkIntro: 'Vous avez ouvert le lien de vérification. Confirmez pour vous connecter',
    mfaLinkDevice: 'sur cet appareil',
    mfaLinkButton: 'Se connecter sur cet appareil',
    backToLogin: 'Retour à la connexion',
    linkInvalid: 'Le lien est invalide ou a expiré.',
    recoveryIntro: 'Saisissez votre email et nous vous enverrons les instructions pour réinitialiser votre mot de passe.',
    emailRequired: "L'email est obligatoire.",
    requestError: 'Impossible de traiter la demande.',
    sending: 'Envoi...',
    sendInstructions: 'Envoyer les instructions',
    recoverySent1: "Nous avons envoyé un email à l'adresse indiquée.",
    recoverySent2: 'Suivez les étapes pour récupérer votre mot de passe.',
    backToHome: "Retour à l'accueil",
    assignIntro: 'Choisissez un nouveau mot de passe sécurisé pour votre compte.',
    newPassword: 'Nouveau mot de passe',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    passwordHint: 'Min. 8 caractères, une majuscule, un chiffre et un symbole.',
    pwMin: 'Minimum 8 caractères.',
    pwUpper: 'Doit contenir au moins une majuscule.',
    pwNumber: 'Doit contenir au moins un chiffre.',
    pwSymbol: 'Doit contenir au moins un symbole.',
    pwMismatch: 'Les mots de passe ne correspondent pas.',
    assignLinkInvalid: 'Lien de changement de mot de passe invalide.',
    saveError: "Impossible d'enregistrer le mot de passe.",
    saving: 'Enregistrement...',
    savePassword: 'Enregistrer le mot de passe',
    assignSuccess1: 'Votre mot de passe a été modifié avec succès.',
    assignSuccess2: 'Vous pouvez maintenant vous connecter.',
  },
  de: {
    noAccessProduct: 'Ihr VACWAY-Konto hat noch keinen Zugang zu {product}.',
    requestInfo: 'Informationen anfordern',
    requestInfoSent: 'Anfrage gesendet! Wir melden uns in Kürze bei Ihnen.',
    email: 'E-Mail',
    password: 'Passwort',
    emailPlaceholder: 'du@email.com',
    securityCheck: 'Sicherheitsprüfung',
    newQuestion: 'Neue Frage',
    forgotPassword: 'Passwort vergessen?',
    signIn: 'Anmelden',
    signingIn: 'Anmeldung...',
    emailPasswordRequired: 'E-Mail und Passwort sind erforderlich.',
    captchaRequired: 'Bitte beantworte die Sicherheitsprüfung.',
    captchaWrong: 'Falsche Antwort bei der Sicherheitsprüfung.',
    tooManyAttempts: 'Zu viele fehlgeschlagene Versuche. Warte {time}.',
    blocked: 'Zugang vorübergehend gesperrt.',
    loginError: 'Fehler bei der Anmeldung.',
    or: 'oder',
    googleSignIn: 'Mit Google anmelden',
    microsoftSignIn: 'Mit Microsoft anmelden',
    googleError: 'Anmeldung mit Google fehlgeschlagen.',
    microsoftError: 'Anmeldung mit Microsoft fehlgeschlagen.',
    adminMode: 'ADMINISTRATORMODUS',
    promoterMode: 'PROMOTER-MODUS',
    mfaSent: 'Wir haben einen Bestätigungscode an deine E-Mail-Adresse gesendet. Gib ihn ein, um fortzufahren.',
    mfaCodeLabel: 'Bestätigungscode',
    verify: 'Bestätigen',
    verifying: 'Überprüfung...',
    resendCode: 'Code erneut senden',
    back: 'Zurück',
    mfaCodeRequired: 'Gib den Bestätigungscode ein.',
    mfaNewCodeSent: 'Wir haben dir einen neuen Code gesendet.',
    mfaResendError: 'Der Code konnte nicht erneut gesendet werden.',
    waitSeconds: 'Warte {s}s.',
    codeWrong: 'Falscher Code.',
    attemptsRemaining: '{n} Versuche übrig',
    mfaLinkIntro: 'Du hast den Bestätigungslink geöffnet. Bestätige die Anmeldung',
    mfaLinkDevice: 'auf diesem Gerät',
    mfaLinkButton: 'Auf diesem Gerät anmelden',
    backToLogin: 'Zurück zur Anmeldung',
    linkInvalid: 'Der Link ist ungültig oder abgelaufen.',
    recoveryIntro: 'Gib deine E-Mail-Adresse ein und wir senden dir Anweisungen zum Zurücksetzen deines Passworts.',
    emailRequired: 'E-Mail ist erforderlich.',
    requestError: 'Die Anfrage konnte nicht verarbeitet werden.',
    sending: 'Senden...',
    sendInstructions: 'Anweisungen senden',
    recoverySent1: 'Wir haben eine E-Mail an die angegebene Adresse gesendet.',
    recoverySent2: 'Folge den Schritten, um dein Passwort wiederherzustellen.',
    backToHome: 'Zurück zur Startseite',
    assignIntro: 'Wähle ein neues sicheres Passwort für dein Konto.',
    newPassword: 'Neues Passwort',
    confirmPasswordLabel: 'Passwort bestätigen',
    passwordHint: 'Mind. 8 Zeichen, ein Großbuchstabe, eine Zahl und ein Symbol.',
    pwMin: 'Mindestens 8 Zeichen.',
    pwUpper: 'Muss mindestens einen Großbuchstaben enthalten.',
    pwNumber: 'Muss mindestens eine Zahl enthalten.',
    pwSymbol: 'Muss mindestens ein Symbol enthalten.',
    pwMismatch: 'Die Passwörter stimmen nicht überein.',
    assignLinkInvalid: 'Ungültiger Link zum Zurücksetzen des Passworts.',
    saveError: 'Das Passwort konnte nicht gespeichert werden.',
    saving: 'Speichern...',
    savePassword: 'Passwort speichern',
    assignSuccess1: 'Dein Passwort wurde erfolgreich geändert.',
    assignSuccess2: 'Du kannst dich jetzt anmelden.',
  },
  it: {
    noAccessProduct: 'Il tuo account VACWAY non ha ancora accesso a {product}.',
    requestInfo: 'Richiedi informazioni',
    requestInfoSent: 'Richiesta inviata! Ti contatteremo al più presto.',
    email: 'Email',
    password: 'Password',
    emailPlaceholder: 'tu@email.com',
    securityCheck: 'Verifica di sicurezza',
    newQuestion: 'Nuova domanda',
    forgotPassword: 'Hai dimenticato la password?',
    signIn: 'Accedi',
    signingIn: 'Accesso...',
    emailPasswordRequired: 'Email e password sono obbligatorie.',
    captchaRequired: 'Devi rispondere alla verifica di sicurezza.',
    captchaWrong: 'Risposta di verifica errata.',
    tooManyAttempts: 'Troppi tentativi falliti. Attendi {time}.',
    blocked: 'Accesso temporaneamente bloccato.',
    loginError: 'Errore di accesso.',
    or: 'o',
    googleSignIn: 'Accedi con Google',
    microsoftSignIn: 'Accedi con Microsoft',
    googleError: 'Impossibile accedere con Google.',
    microsoftError: 'Impossibile accedere con Microsoft.',
    adminMode: 'MODALITÀ AMMINISTRATORE',
    promoterMode: 'MODALITÀ PROMOTER',
    mfaSent: 'Abbiamo inviato un codice di verifica alla tua email. Inseriscilo per continuare.',
    mfaCodeLabel: 'Codice di verifica',
    verify: 'Verifica',
    verifying: 'Verifica in corso...',
    resendCode: 'Invia di nuovo il codice',
    back: 'Indietro',
    mfaCodeRequired: 'Inserisci il codice di verifica.',
    mfaNewCodeSent: 'Ti abbiamo inviato un nuovo codice.',
    mfaResendError: 'Impossibile inviare di nuovo il codice.',
    waitSeconds: 'Attendi {s}s.',
    codeWrong: 'Codice errato.',
    attemptsRemaining: '{n} tentativi rimanenti',
    mfaLinkIntro: 'Hai aperto il link di verifica. Conferma per accedere',
    mfaLinkDevice: 'su questo dispositivo',
    mfaLinkButton: 'Accedi su questo dispositivo',
    backToLogin: "Torna all'accesso",
    linkInvalid: 'Il link non è valido o è scaduto.',
    recoveryIntro: 'Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.',
    emailRequired: "L'email è obbligatoria.",
    requestError: 'Impossibile elaborare la richiesta.',
    sending: 'Invio...',
    sendInstructions: 'Invia istruzioni',
    recoverySent1: "Abbiamo inviato un'email all'indirizzo indicato.",
    recoverySent2: 'Segui i passaggi per recuperare la password.',
    backToHome: 'Torna alla home',
    assignIntro: 'Scegli una nuova password sicura per il tuo account.',
    newPassword: 'Nuova password',
    confirmPasswordLabel: 'Conferma password',
    passwordHint: 'Min. 8 caratteri, una maiuscola, un numero e un simbolo.',
    pwMin: 'Minimo 8 caratteri.',
    pwUpper: 'Deve includere almeno una lettera maiuscola.',
    pwNumber: 'Deve includere almeno un numero.',
    pwSymbol: 'Deve includere almeno un simbolo.',
    pwMismatch: 'Le password non coincidono.',
    assignLinkInvalid: 'Link di modifica password non valido.',
    saveError: 'Impossibile salvare la password.',
    saving: 'Salvataggio...',
    savePassword: 'Salva password',
    assignSuccess1: 'La tua password è stata modificata correttamente.',
    assignSuccess2: 'Ora puoi accedere.',
  },
  pt: {
    noAccessProduct: 'A tua conta VACWAY ainda não tem acesso a {product}.',
    requestInfo: 'Pedir informações',
    requestInfoSent: 'Pedido enviado! Entraremos em contacto muito em breve.',
    email: 'Email',
    password: 'Palavra-passe',
    emailPlaceholder: 'tu@email.com',
    securityCheck: 'Verificação de segurança',
    newQuestion: 'Nova pergunta',
    forgotPassword: 'Esqueceu-se da palavra-passe?',
    signIn: 'Entrar',
    signingIn: 'A entrar...',
    emailPasswordRequired: 'Email e palavra-passe são obrigatórios.',
    captchaRequired: 'Tem de responder à verificação de segurança.',
    captchaWrong: 'Resposta de verificação incorreta.',
    tooManyAttempts: 'Demasiadas tentativas falhadas. Aguarde {time}.',
    blocked: 'Acesso temporariamente bloqueado.',
    loginError: 'Erro ao iniciar sessão.',
    or: 'ou',
    googleSignIn: 'Iniciar sessão com Google',
    microsoftSignIn: 'Iniciar sessão com Microsoft',
    googleError: 'Não foi possível iniciar sessão com Google.',
    microsoftError: 'Não foi possível iniciar sessão com Microsoft.',
    adminMode: 'MODO ADMINISTRADOR',
    promoterMode: 'MODO PROMOTOR',
    mfaSent: 'Enviámos um código de verificação para o seu email. Introduza-o para continuar.',
    mfaCodeLabel: 'Código de verificação',
    verify: 'Verificar',
    verifying: 'A verificar...',
    resendCode: 'Reenviar código',
    back: 'Voltar',
    mfaCodeRequired: 'Introduza o código de verificação.',
    mfaNewCodeSent: 'Enviámos-lhe um novo código.',
    mfaResendError: 'Não foi possível reenviar o código.',
    waitSeconds: 'Aguarde {s}s.',
    codeWrong: 'Código incorreto.',
    attemptsRemaining: '{n} tentativas restantes',
    mfaLinkIntro: 'Abriu a ligação de verificação. Confirme para iniciar sessão',
    mfaLinkDevice: 'neste dispositivo',
    mfaLinkButton: 'Entrar neste dispositivo',
    backToLogin: 'Voltar ao início de sessão',
    linkInvalid: 'A ligação é inválida ou expirou.',
    recoveryIntro: 'Introduza o seu email e enviaremos instruções para repor a palavra-passe.',
    emailRequired: 'O email é obrigatório.',
    requestError: 'Não foi possível processar o pedido.',
    sending: 'A enviar...',
    sendInstructions: 'Enviar instruções',
    recoverySent1: 'Enviámos um email para o endereço indicado.',
    recoverySent2: 'Siga os passos para recuperar a palavra-passe.',
    backToHome: 'Voltar ao início',
    assignIntro: 'Escolha uma nova palavra-passe segura para a sua conta.',
    newPassword: 'Nova palavra-passe',
    confirmPasswordLabel: 'Confirmar palavra-passe',
    passwordHint: 'Mín. 8 caracteres, uma maiúscula, um número e um símbolo.',
    pwMin: 'Mínimo de 8 caracteres.',
    pwUpper: 'Deve incluir pelo menos uma maiúscula.',
    pwNumber: 'Deve incluir pelo menos um número.',
    pwSymbol: 'Deve incluir pelo menos um símbolo.',
    pwMismatch: 'As palavras-passe não coincidem.',
    assignLinkInvalid: 'Ligação de alteração de palavra-passe inválida.',
    saveError: 'Não foi possível guardar a palavra-passe.',
    saving: 'A guardar...',
    savePassword: 'Guardar palavra-passe',
    assignSuccess1: 'A sua palavra-passe foi alterada com sucesso.',
    assignSuccess2: 'Já pode iniciar sessão.',
  },
  pl: {
    noAccessProduct: 'Twoje konto VACWAY nie ma jeszcze dostępu do {product}.',
    requestInfo: 'Poproś o informacje',
    requestInfoSent: 'Prośba wysłana! Skontaktujemy się wkrótce.',
    email: 'E-mail',
    password: 'Hasło',
    emailPlaceholder: 'ty@email.com',
    securityCheck: 'Weryfikacja bezpieczeństwa',
    newQuestion: 'Nowe pytanie',
    forgotPassword: 'Nie pamiętasz hasła?',
    signIn: 'Zaloguj się',
    signingIn: 'Logowanie...',
    emailPasswordRequired: 'E-mail i hasło są wymagane.',
    captchaRequired: 'Musisz odpowiedzieć na pytanie weryfikacyjne.',
    captchaWrong: 'Nieprawidłowa odpowiedź weryfikacyjna.',
    tooManyAttempts: 'Zbyt wiele nieudanych prób. Poczekaj {time}.',
    blocked: 'Dostęp tymczasowo zablokowany.',
    loginError: 'Błąd logowania.',
    or: 'lub',
    googleSignIn: 'Zaloguj się przez Google',
    microsoftSignIn: 'Zaloguj się przez Microsoft',
    googleError: 'Nie udało się zalogować przez Google.',
    microsoftError: 'Nie udało się zalogować przez Microsoft.',
    adminMode: 'TRYB ADMINISTRATORA',
    promoterMode: 'TRYB PROMOTORA',
    mfaSent: 'Wysłaliśmy kod weryfikacyjny na Twój adres e-mail. Wpisz go, aby kontynuować.',
    mfaCodeLabel: 'Kod weryfikacyjny',
    verify: 'Zweryfikuj',
    verifying: 'Weryfikacja...',
    resendCode: 'Wyślij kod ponownie',
    back: 'Wstecz',
    mfaCodeRequired: 'Wpisz kod weryfikacyjny.',
    mfaNewCodeSent: 'Wysłaliśmy Ci nowy kod.',
    mfaResendError: 'Nie udało się ponownie wysłać kodu.',
    waitSeconds: 'Poczekaj {s}s.',
    codeWrong: 'Nieprawidłowy kod.',
    attemptsRemaining: 'pozostało prób: {n}',
    mfaLinkIntro: 'Link weryfikacyjny został otwarty. Potwierdź, aby zalogować się',
    mfaLinkDevice: 'na tym urządzeniu',
    mfaLinkButton: 'Zaloguj się na tym urządzeniu',
    backToLogin: 'Powrót do logowania',
    linkInvalid: 'Link jest nieprawidłowy lub wygasł.',
    recoveryIntro: 'Podaj swój e-mail, a wyślemy Ci instrukcje resetowania hasła.',
    emailRequired: 'E-mail jest wymagany.',
    requestError: 'Nie udało się przetworzyć żądania.',
    sending: 'Wysyłanie...',
    sendInstructions: 'Wyślij instrukcje',
    recoverySent1: 'Wysłaliśmy wiadomość na podany adres e-mail.',
    recoverySent2: 'Postępuj zgodnie z instrukcjami, aby odzyskać hasło.',
    backToHome: 'Powrót do strony głównej',
    assignIntro: 'Wybierz nowe bezpieczne hasło do swojego konta.',
    newPassword: 'Nowe hasło',
    confirmPasswordLabel: 'Potwierdź hasło',
    passwordHint: 'Min. 8 znaków, wielka litera, cyfra i symbol.',
    pwMin: 'Minimum 8 znaków.',
    pwUpper: 'Musi zawierać co najmniej jedną wielką literę.',
    pwNumber: 'Musi zawierać co najmniej jedną cyfrę.',
    pwSymbol: 'Musi zawierać co najmniej jeden symbol.',
    pwMismatch: 'Hasła nie są zgodne.',
    assignLinkInvalid: 'Nieprawidłowy link zmiany hasła.',
    saveError: 'Nie udało się zapisać hasła.',
    saving: 'Zapisywanie...',
    savePassword: 'Zapisz hasło',
    assignSuccess1: 'Twoje hasło zostało pomyślnie zmienione.',
    assignSuccess2: 'Możesz się teraz zalogować.',
  },
  tr: {
    noAccessProduct: 'VACWAY hesabınızın {product} erişimi henüz yok.',
    requestInfo: 'Bilgi talep et',
    requestInfoSent: 'Talep gönderildi! En kısa sürede sizinle iletişime geçeceğiz.',
    email: 'E-posta',
    password: 'Şifre',
    emailPlaceholder: 'sen@email.com',
    securityCheck: 'Güvenlik doğrulaması',
    newQuestion: 'Yeni soru',
    forgotPassword: 'Şifrenizi mi unuttunuz?',
    signIn: 'Giriş yap',
    signingIn: 'Giriş yapılıyor...',
    emailPasswordRequired: 'E-posta ve şifre zorunludur.',
    captchaRequired: 'Güvenlik doğrulamasını yanıtlamalısınız.',
    captchaWrong: 'Doğrulama yanıtı yanlış.',
    tooManyAttempts: 'Çok fazla başarısız deneme. {time} bekleyin.',
    blocked: 'Erişim geçici olarak engellendi.',
    loginError: 'Giriş yapılırken hata oluştu.',
    or: 'veya',
    googleSignIn: 'Google ile giriş yap',
    microsoftSignIn: 'Microsoft ile giriş yap',
    googleError: 'Google ile giriş yapılamadı.',
    microsoftError: 'Microsoft ile giriş yapılamadı.',
    adminMode: 'YÖNETİCİ MODU',
    promoterMode: 'PROMOTÖR MODU',
    mfaSent: 'E-posta adresinize bir doğrulama kodu gönderdik. Devam etmek için kodu girin.',
    mfaCodeLabel: 'Doğrulama kodu',
    verify: 'Doğrula',
    verifying: 'Doğrulanıyor...',
    resendCode: 'Kodu tekrar gönder',
    back: 'Geri',
    mfaCodeRequired: 'Doğrulama kodunu girin.',
    mfaNewCodeSent: 'Size yeni bir kod gönderdik.',
    mfaResendError: 'Kod tekrar gönderilemedi.',
    waitSeconds: '{s} sn bekleyin.',
    codeWrong: 'Kod yanlış.',
    attemptsRemaining: '{n} deneme hakkı kaldı',
    mfaLinkIntro: 'Doğrulama bağlantısını açtınız. Oturum açmayı onaylayın:',
    mfaLinkDevice: 'bu cihazda',
    mfaLinkButton: 'Bu cihazda giriş yap',
    backToLogin: 'Girişe geri dön',
    linkInvalid: 'Bağlantı geçersiz veya süresi dolmuş.',
    recoveryIntro: 'E-posta adresinizi girin, şifrenizi sıfırlamanız için talimat gönderelim.',
    emailRequired: 'E-posta zorunludur.',
    requestError: 'İstek işlenemedi.',
    sending: 'Gönderiliyor...',
    sendInstructions: 'Talimatları gönder',
    recoverySent1: 'Belirtilen e-posta adresine bir e-posta gönderdik.',
    recoverySent2: 'Şifrenizi kurtarmak için adımları izleyin.',
    backToHome: 'Ana sayfaya dön',
    assignIntro: 'Hesabınız için yeni ve güvenli bir şifre seçin.',
    newPassword: 'Yeni şifre',
    confirmPasswordLabel: 'Şifreyi onayla',
    passwordHint: 'En az 8 karakter, bir büyük harf, bir rakam ve bir sembol.',
    pwMin: 'En az 8 karakter.',
    pwUpper: 'En az bir büyük harf içermelidir.',
    pwNumber: 'En az bir rakam içermelidir.',
    pwSymbol: 'En az bir sembol içermelidir.',
    pwMismatch: 'Şifreler eşleşmiyor.',
    assignLinkInvalid: 'Geçersiz şifre değiştirme bağlantısı.',
    saveError: 'Şifre kaydedilemedi.',
    saving: 'Kaydediliyor...',
    savePassword: 'Şifreyi kaydet',
    assignSuccess1: 'Şifreniz başarıyla değiştirildi.',
    assignSuccess2: 'Artık giriş yapabilirsiniz.',
  },
  cs: {
    noAccessProduct: 'Váš účet VACWAY zatím nemá přístup k {product}.',
    requestInfo: 'Vyžádat informace',
    requestInfoSent: 'Žádost odeslána! Brzy se vám ozveme.',
    email: 'E-mail',
    password: 'Heslo',
    emailPlaceholder: 'ty@email.com',
    securityCheck: 'Bezpečnostní ověření',
    newQuestion: 'Nová otázka',
    forgotPassword: 'Zapomněli jste heslo?',
    signIn: 'Přihlásit se',
    signingIn: 'Přihlašování...',
    emailPasswordRequired: 'E-mail a heslo jsou povinné.',
    captchaRequired: 'Musíte odpovědět na bezpečnostní ověření.',
    captchaWrong: 'Nesprávná odpověď na ověření.',
    tooManyAttempts: 'Příliš mnoho neúspěšných pokusů. Počkejte {time}.',
    blocked: 'Přístup dočasně zablokován.',
    loginError: 'Chyba při přihlašování.',
    or: 'nebo',
    googleSignIn: 'Přihlásit se přes Google',
    microsoftSignIn: 'Přihlásit se přes Microsoft',
    googleError: 'Přihlášení přes Google se nezdařilo.',
    microsoftError: 'Přihlášení přes Microsoft se nezdařilo.',
    adminMode: 'REŽIM ADMINISTRÁTORA',
    promoterMode: 'REŽIM PROMOTÉRA',
    mfaSent: 'Na váš e-mail jsme odeslali ověřovací kód. Zadejte ho pro pokračování.',
    mfaCodeLabel: 'Ověřovací kód',
    verify: 'Ověřit',
    verifying: 'Ověřování...',
    resendCode: 'Znovu odeslat kód',
    back: 'Zpět',
    mfaCodeRequired: 'Zadejte ověřovací kód.',
    mfaNewCodeSent: 'Poslali jsme vám nový kód.',
    mfaResendError: 'Kód se nepodařilo znovu odeslat.',
    waitSeconds: 'Počkejte {s} s.',
    codeWrong: 'Nesprávný kód.',
    attemptsRemaining: 'zbývá pokusů: {n}',
    mfaLinkIntro: 'Otevřeli jste ověřovací odkaz. Potvrďte přihlášení',
    mfaLinkDevice: 'na tomto zařízení',
    mfaLinkButton: 'Přihlásit se na tomto zařízení',
    backToLogin: 'Zpět na přihlášení',
    linkInvalid: 'Odkaz je neplatný nebo vypršel.',
    recoveryIntro: 'Zadejte svůj e-mail a my vám pošleme pokyny k obnovení hesla.',
    emailRequired: 'E-mail je povinný.',
    requestError: 'Požadavek se nepodařilo zpracovat.',
    sending: 'Odesílání...',
    sendInstructions: 'Odeslat pokyny',
    recoverySent1: 'Na uvedený e-mail jsme odeslali zprávu.',
    recoverySent2: 'Postupujte podle kroků k obnovení hesla.',
    backToHome: 'Zpět na úvod',
    assignIntro: 'Zvolte nové bezpečné heslo ke svému účtu.',
    newPassword: 'Nové heslo',
    confirmPasswordLabel: 'Potvrdit heslo',
    passwordHint: 'Min. 8 znaků, velké písmeno, číslice a symbol.',
    pwMin: 'Minimálně 8 znaků.',
    pwUpper: 'Musí obsahovat alespoň jedno velké písmeno.',
    pwNumber: 'Musí obsahovat alespoň jednu číslici.',
    pwSymbol: 'Musí obsahovat alespoň jeden symbol.',
    pwMismatch: 'Hesla se neshodují.',
    assignLinkInvalid: 'Neplatný odkaz pro změnu hesla.',
    saveError: 'Heslo se nepodařilo uložit.',
    saving: 'Ukládání...',
    savePassword: 'Uložit heslo',
    assignSuccess1: 'Vaše heslo bylo úspěšně změněno.',
    assignSuccess2: 'Nyní se můžete přihlásit.',
  },
  sk: {
    noAccessProduct: 'Váš účet VACWAY zatiaľ nemá prístup k {product}.',
    requestInfo: 'Vyžiadať informácie',
    requestInfoSent: 'Žiadosť odoslaná! Čoskoro sa vám ozveme.',
    email: 'E-mail',
    password: 'Heslo',
    emailPlaceholder: 'ty@email.com',
    securityCheck: 'Bezpečnostné overenie',
    newQuestion: 'Nová otázka',
    forgotPassword: 'Zabudli ste heslo?',
    signIn: 'Prihlásiť sa',
    signingIn: 'Prihlasovanie...',
    emailPasswordRequired: 'E-mail a heslo sú povinné.',
    captchaRequired: 'Musíte odpovedať na bezpečnostné overenie.',
    captchaWrong: 'Nesprávna odpoveď na overenie.',
    tooManyAttempts: 'Príliš veľa neúspešných pokusov. Počkajte {time}.',
    blocked: 'Prístup dočasne zablokovaný.',
    loginError: 'Chyba pri prihlasovaní.',
    or: 'alebo',
    googleSignIn: 'Prihlásiť sa cez Google',
    microsoftSignIn: 'Prihlásiť sa cez Microsoft',
    googleError: 'Prihlásenie cez Google zlyhalo.',
    microsoftError: 'Prihlásenie cez Microsoft zlyhalo.',
    adminMode: 'REŽIM ADMINISTRÁTORA',
    promoterMode: 'REŽIM PROMOTÉRA',
    mfaSent: 'Na váš e-mail sme odoslali overovací kód. Zadajte ho pre pokračovanie.',
    mfaCodeLabel: 'Overovací kód',
    verify: 'Overiť',
    verifying: 'Overovanie...',
    resendCode: 'Znova odoslať kód',
    back: 'Späť',
    mfaCodeRequired: 'Zadajte overovací kód.',
    mfaNewCodeSent: 'Poslali sme vám nový kód.',
    mfaResendError: 'Kód sa nepodarilo znova odoslať.',
    waitSeconds: 'Počkajte {s} s.',
    codeWrong: 'Nesprávny kód.',
    attemptsRemaining: 'zostáva pokusov: {n}',
    mfaLinkIntro: 'Otvorili ste overovací odkaz. Potvrďte prihlásenie',
    mfaLinkDevice: 'na tomto zariadení',
    mfaLinkButton: 'Prihlásiť sa na tomto zariadení',
    backToLogin: 'Späť na prihlásenie',
    linkInvalid: 'Odkaz je neplatný alebo vypršal.',
    recoveryIntro: 'Zadajte svoj e-mail a pošleme vám pokyny na obnovenie hesla.',
    emailRequired: 'E-mail je povinný.',
    requestError: 'Požiadavku sa nepodarilo spracovať.',
    sending: 'Odosielanie...',
    sendInstructions: 'Odoslať pokyny',
    recoverySent1: 'Na uvedený e-mail sme odoslali správu.',
    recoverySent2: 'Postupujte podľa krokov na obnovenie hesla.',
    backToHome: 'Späť na úvod',
    assignIntro: 'Zvoľte si nové bezpečné heslo k svojmu účtu.',
    newPassword: 'Nové heslo',
    confirmPasswordLabel: 'Potvrdiť heslo',
    passwordHint: 'Min. 8 znakov, veľké písmeno, číslica a symbol.',
    pwMin: 'Minimálne 8 znakov.',
    pwUpper: 'Musí obsahovať aspoň jedno veľké písmeno.',
    pwNumber: 'Musí obsahovať aspoň jednu číslicu.',
    pwSymbol: 'Musí obsahovať aspoň jeden symbol.',
    pwMismatch: 'Heslá sa nezhodujú.',
    assignLinkInvalid: 'Neplatný odkaz na zmenu hesla.',
    saveError: 'Heslo sa nepodarilo uložiť.',
    saving: 'Ukladanie...',
    savePassword: 'Uložiť heslo',
    assignSuccess1: 'Vaše heslo bolo úspešne zmenené.',
    assignSuccess2: 'Teraz sa môžete prihlásiť.',
  },
  ca: {
    noAccessProduct: 'El teu compte VACWAY encara no té accés a {product}.',
    requestInfo: 'Sol·licitar informació',
    requestInfoSent: 'Sol·licitud enviada! Et contactarem molt aviat.',
    email: 'Email',
    password: 'Contrasenya',
    emailPlaceholder: 'tu@email.com',
    securityCheck: 'Verificació de seguretat',
    newQuestion: 'Nova pregunta',
    forgotPassword: 'Has oblidat la contrasenya?',
    signIn: 'Entrar',
    signingIn: 'Entrant...',
    emailPasswordRequired: "L'email i la contrasenya són obligatoris.",
    captchaRequired: 'Has de respondre la verificació de seguretat.',
    captchaWrong: 'Resposta de verificació incorrecta.',
    tooManyAttempts: 'Massa intents fallits. Espera {time}.',
    blocked: 'Accés temporalment bloquejat.',
    loginError: 'Error en iniciar sessió.',
    or: 'o',
    googleSignIn: 'Inicia sessió amb Google',
    microsoftSignIn: 'Inicia sessió amb Microsoft',
    googleError: "No s'ha pogut iniciar sessió amb Google.",
    microsoftError: "No s'ha pogut iniciar sessió amb Microsoft.",
    adminMode: 'MODE ADMINISTRADOR',
    promoterMode: 'MODE PROMOTOR',
    mfaSent: 'Hem enviat un codi de verificació al teu correu electrònic. Introdueix-lo per continuar.',
    mfaCodeLabel: 'Codi de verificació',
    verify: 'Verificar',
    verifying: 'Verificant...',
    resendCode: 'Reenviar el codi',
    back: 'Tornar',
    mfaCodeRequired: 'Introdueix el codi de verificació.',
    mfaNewCodeSent: "T'hem enviat un codi nou.",
    mfaResendError: "No s'ha pogut reenviar el codi.",
    waitSeconds: 'Espera {s}s.',
    codeWrong: 'Codi incorrecte.',
    attemptsRemaining: '{n} intents restants',
    mfaLinkIntro: "Has obert l'enllaç de verificació. Confirma per iniciar sessió",
    mfaLinkDevice: 'en aquest dispositiu',
    mfaLinkButton: 'Entrar en aquest dispositiu',
    backToLogin: "Tornar a l'inici de sessió",
    linkInvalid: "L'enllaç no és vàlid o ha caducat.",
    recoveryIntro: "Introdueix el teu email i t'enviarem instruccions per restablir la contrasenya.",
    emailRequired: "L'email és obligatori.",
    requestError: "No s'ha pogut processar la sol·licitud.",
    sending: 'Enviant...',
    sendInstructions: 'Enviar instruccions',
    recoverySent1: "Hem enviat un correu a l'email facilitat.",
    recoverySent2: 'Segueix els passos per recuperar la contrasenya.',
    backToHome: "Tornar a l'inici",
    assignIntro: 'Tria una nova contrasenya segura per al teu compte.',
    newPassword: 'Nova contrasenya',
    confirmPasswordLabel: 'Confirmar contrasenya',
    passwordHint: 'Mín. 8 caràcters, una majúscula, un número i un símbol.',
    pwMin: 'Mínim 8 caràcters.',
    pwUpper: "Ha d'incloure almenys una majúscula.",
    pwNumber: "Ha d'incloure almenys un número.",
    pwSymbol: "Ha d'incloure almenys un símbol.",
    pwMismatch: 'Les contrasenyes no coincideixen.',
    assignLinkInvalid: 'Enllaç de canvi de contrasenya no vàlid.',
    saveError: "No s'ha pogut desar la contrasenya.",
    saving: 'Desant...',
    savePassword: 'Desar contrasenya',
    assignSuccess1: "La teva contrasenya s'ha canviat correctament.",
    assignSuccess2: 'Ja pots iniciar sessió.',
  },
  nl: {
    noAccessProduct: 'Je VACWAY-account heeft nog geen toegang tot {product}.',
    requestInfo: 'Informatie aanvragen',
    requestInfoSent: 'Aanvraag verzonden! We nemen snel contact met je op.',
    email: 'E-mail',
    password: 'Wachtwoord',
    emailPlaceholder: 'jij@email.com',
    securityCheck: 'Veiligheidscontrole',
    newQuestion: 'Nieuwe vraag',
    forgotPassword: 'Wachtwoord vergeten?',
    signIn: 'Inloggen',
    signingIn: 'Inloggen...',
    emailPasswordRequired: 'E-mail en wachtwoord zijn verplicht.',
    captchaRequired: 'Beantwoord de veiligheidscontrole.',
    captchaWrong: 'Onjuist antwoord op de veiligheidscontrole.',
    tooManyAttempts: 'Te veel mislukte pogingen. Wacht {time}.',
    blocked: 'Toegang tijdelijk geblokkeerd.',
    loginError: 'Fout bij het inloggen.',
    or: 'of',
    googleSignIn: 'Inloggen met Google',
    microsoftSignIn: 'Inloggen met Microsoft',
    googleError: 'Inloggen met Google is mislukt.',
    microsoftError: 'Inloggen met Microsoft is mislukt.',
    adminMode: 'BEHEERDERSMODUS',
    promoterMode: 'PROMOTORMODUS',
    mfaSent: 'We hebben een verificatiecode naar je e-mail gestuurd. Voer deze in om door te gaan.',
    mfaCodeLabel: 'Verificatiecode',
    verify: 'Verifiëren',
    verifying: 'Verifiëren...',
    resendCode: 'Code opnieuw versturen',
    back: 'Terug',
    mfaCodeRequired: 'Voer de verificatiecode in.',
    mfaNewCodeSent: 'We hebben je een nieuwe code gestuurd.',
    mfaResendError: 'De code kon niet opnieuw worden verstuurd.',
    waitSeconds: 'Wacht {s}s.',
    codeWrong: 'Onjuiste code.',
    attemptsRemaining: '{n} pogingen over',
    mfaLinkIntro: 'Je hebt de verificatielink geopend. Bevestig om in te loggen',
    mfaLinkDevice: 'op dit apparaat',
    mfaLinkButton: 'Inloggen op dit apparaat',
    backToLogin: 'Terug naar inloggen',
    linkInvalid: 'De link is ongeldig of verlopen.',
    recoveryIntro: 'Voer je e-mail in en we sturen je instructies om je wachtwoord opnieuw in te stellen.',
    emailRequired: 'E-mail is verplicht.',
    requestError: 'Het verzoek kon niet worden verwerkt.',
    sending: 'Versturen...',
    sendInstructions: 'Instructies versturen',
    recoverySent1: 'We hebben een e-mail gestuurd naar het opgegeven adres.',
    recoverySent2: 'Volg de stappen om je wachtwoord te herstellen.',
    backToHome: 'Terug naar start',
    assignIntro: 'Kies een nieuw veilig wachtwoord voor je account.',
    newPassword: 'Nieuw wachtwoord',
    confirmPasswordLabel: 'Bevestig wachtwoord',
    passwordHint: 'Min. 8 tekens, een hoofdletter, een cijfer en een symbool.',
    pwMin: 'Minimaal 8 tekens.',
    pwUpper: 'Moet minstens één hoofdletter bevatten.',
    pwNumber: 'Moet minstens één cijfer bevatten.',
    pwSymbol: 'Moet minstens één symbool bevatten.',
    pwMismatch: 'De wachtwoorden komen niet overeen.',
    assignLinkInvalid: 'Ongeldige link voor wachtwoordwijziging.',
    saveError: 'Het wachtwoord kon niet worden opgeslagen.',
    saving: 'Opslaan...',
    savePassword: 'Wachtwoord opslaan',
    assignSuccess1: 'Je wachtwoord is gewijzigd.',
    assignSuccess2: 'Je kunt nu inloggen.',
  },
  no: {
    noAccessProduct: 'VACWAY-kontoen din har ennå ikke tilgang til {product}.',
    requestInfo: 'Be om informasjon',
    requestInfoSent: 'Forespørsel sendt! Vi kontakter deg snart.',
    email: 'E-post',
    password: 'Passord',
    emailPlaceholder: 'du@email.com',
    securityCheck: 'Sikkerhetskontroll',
    newQuestion: 'Nytt spørsmål',
    forgotPassword: 'Glemt passordet?',
    signIn: 'Logg inn',
    signingIn: 'Logger inn...',
    emailPasswordRequired: 'E-post og passord er obligatorisk.',
    captchaRequired: 'Du må svare på sikkerhetskontrollen.',
    captchaWrong: 'Feil svar på sikkerhetskontrollen.',
    tooManyAttempts: 'For mange mislykkede forsøk. Vent {time}.',
    blocked: 'Tilgang midlertidig blokkert.',
    loginError: 'Feil ved innlogging.',
    or: 'eller',
    googleSignIn: 'Logg inn med Google',
    microsoftSignIn: 'Logg inn med Microsoft',
    googleError: 'Kunne ikke logge inn med Google.',
    microsoftError: 'Kunne ikke logge inn med Microsoft.',
    adminMode: 'ADMINISTRATORMODUS',
    promoterMode: 'PROMOTØRMODUS',
    mfaSent: 'Vi har sendt en bekreftelseskode til e-posten din. Skriv den inn for å fortsette.',
    mfaCodeLabel: 'Bekreftelseskode',
    verify: 'Bekreft',
    verifying: 'Bekrefter...',
    resendCode: 'Send koden på nytt',
    back: 'Tilbake',
    mfaCodeRequired: 'Skriv inn bekreftelseskoden.',
    mfaNewCodeSent: 'Vi har sendt deg en ny kode.',
    mfaResendError: 'Kunne ikke sende koden på nytt.',
    waitSeconds: 'Vent {s}s.',
    codeWrong: 'Feil kode.',
    attemptsRemaining: '{n} forsøk igjen',
    mfaLinkIntro: 'Du har åpnet bekreftelseslenken. Bekreft for å logge inn',
    mfaLinkDevice: 'på denne enheten',
    mfaLinkButton: 'Logg inn på denne enheten',
    backToLogin: 'Tilbake til innlogging',
    linkInvalid: 'Lenken er ugyldig eller utløpt.',
    recoveryIntro: 'Skriv inn e-posten din, så sender vi deg instruksjoner for å tilbakestille passordet.',
    emailRequired: 'E-post er obligatorisk.',
    requestError: 'Kunne ikke behandle forespørselen.',
    sending: 'Sender...',
    sendInstructions: 'Send instruksjoner',
    recoverySent1: 'Vi har sendt en e-post til adressen du oppga.',
    recoverySent2: 'Følg trinnene for å gjenopprette passordet.',
    backToHome: 'Tilbake til start',
    assignIntro: 'Velg et nytt og sikkert passord for kontoen din.',
    newPassword: 'Nytt passord',
    confirmPasswordLabel: 'Bekreft passord',
    passwordHint: 'Min. 8 tegn, en stor bokstav, et tall og et symbol.',
    pwMin: 'Minst 8 tegn.',
    pwUpper: 'Må inneholde minst én stor bokstav.',
    pwNumber: 'Må inneholde minst ett tall.',
    pwSymbol: 'Må inneholde minst ett symbol.',
    pwMismatch: 'Passordene stemmer ikke overens.',
    assignLinkInvalid: 'Ugyldig lenke for passordendring.',
    saveError: 'Kunne ikke lagre passordet.',
    saving: 'Lagrer...',
    savePassword: 'Lagre passord',
    assignSuccess1: 'Passordet ditt er endret.',
    assignSuccess2: 'Du kan nå logge inn.',
  },
}

const SUPPORTED = LANGS.map(l => l.code)

function detectLang() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored && SUPPORTED.indexOf(stored) !== -1) return stored
  } catch (e) { /* localStorage blocked */ }
  // A googtrans cookie left by the in-app translator (value may be URL-encoded).
  const cookie = document.cookie.match(/googtrans=(?:%2F|\/)[a-z]{2}(?:%2F|\/)([a-z]{2})/i)
  if (cookie && SUPPORTED.indexOf(cookie[1].toLowerCase()) !== -1) return cookie[1].toLowerCase()
  const nav = ((navigator.language || navigator.userLanguage || '').slice(0, 2)).toLowerCase()
  if (SUPPORTED.indexOf(nav) !== -1) return nav
  return 'es'
}

let currentLang = detectLang()

export function getLoginLang() {
  return currentLang
}

export function setLoginLang(code) {
  if (SUPPORTED.indexOf(code) === -1) return
  currentLang = code
  try { window.localStorage.setItem(STORAGE_KEY, code) } catch (e) { /* ignore */ }
  // Keep the in-app Google Translate widget (post-login) on the same language.
  const val = '/es/' + code
  document.cookie = 'googtrans=' + val + '; path=/; domain=.vacway.es'
  document.cookie = 'googtrans=' + val + '; path=/; domain=' + window.location.hostname
  document.cookie = 'googtrans=' + val + '; path=/'
}

export function t(key, vars) {
  const table = STRINGS[currentLang] || STRINGS.es
  let str = table[key] !== undefined ? table[key] : STRINGS.es[key]
  if (str === undefined) return key
  if (vars) {
    Object.keys(vars).forEach(k => { str = str.split('{' + k + '}').join(vars[k]) })
  }
  return str
}
